import React from 'react'
import { useSelector } from "react-redux";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const AdvanceSeondState = (props) => {
    const { datas } = props;
    const dashboardData = useSelector((state) => state.advanceSecondStateSliceCall.AdvanceAttendanceRecords_SecondState);
    const stateNames = [...new Set(dashboardData.map(item => item.FilterName))];


    // const chartData = stateNames.map(state => {
    //     const record = dashboardData.find(item => item.FilterName === state);
    //     return {
    //         state,
    //         present_count: record.present_count || 0,
    //         percentage_attendance: `${record.percentage_attendance}` || 0,
    //         others : record.employee_count - (record.present_count + record.weekoff_count + record.working_count),

    //     };
    // });

    const chartData = stateNames.map(state => {
        const record = dashboardData.find(item => item.FilterName === state) || {};
        const employeeCount = record.employee_count || 0;
        const presentCount = record.present_count || 0;
        const weekoffCount = record.weekoff_count || 0;
        const workingCount = record.working_count || 0;
        const absentCount = record.absent_count || 0;

        let presentPercentage = 0;
        let workingPercentage = 0;
        let othersPercentage = 0;

        if (employeeCount > 0) {
            presentPercentage = (presentCount / employeeCount) * 100;
            workingPercentage = (workingCount / employeeCount) * 100;
            othersPercentage = 100 - (presentPercentage + workingPercentage);
        }

        return {
            state,
            // present_count: presentCount,
            present_percentage: presentPercentage,
            working_percentage: workingPercentage,
            others: othersPercentage,
        };
    });




    const tableHeaderStyle = {
        padding: "10px",
        fontWeight: "500",
        background: "#234492",
        position: "sticky",
        top: 0,
        color: "#fff",
        fontSize: "14px !important",
        textAlign: "center",
        zIndex: 2
    };

    const tableCellStyle = {
        padding: "10px",
        borderBottom: "1px solid #ccc",
        fontSize: "13px"
    };
    const tableHeaderStyleState = {
        padding: "10px",
        fontWeight: "500",
        background: "#234492",
        position: "sticky",
        top: 0,
        color: "#fff",
        fontSize: "14px !important",
        textAlign: "left",
        zIndex: 2,
        borderRadius: "10px 0px 0px 10px"

    };

    const tableHeaderStyleLastState = {
        padding: "10px",
        // borderBottom: "2px solid #ddd",
        fontWeight: "500",
        background: "#234492",
        position: "sticky",
        top: 0,
        color: "#fff",
        fontSize: "14px !important",
        textAlign: "center",
        zIndex: 2,
        borderRadius: "0px 10px 10px 0px"


    };

    return (
        <>

            {/* {dashboardData.length > 0 ? */}
            <div>
                <h5>Top Attendance Details</h5>

                <div className="NormalTableCalls" style={{ maxHeight: "170px", overflowY: "auto", overflowX: "auto", paddingRight: "12px" }}>
                    <table className="TicketingTableOverviewsDashboard TableOverviewsDashboard" style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th style={tableHeaderStyleState}>{datas.state === "" && datas.region === "" && datas.zone === ""
                                    ? "All"
                                    : datas.state !== "" && datas.region === "" && datas.zone === ""
                                        ? "Region"
                                        : datas.state !== "" && datas.region !== "" && datas.zone === ""
                                            ? "Zone"
                                            : datas.state !== "" && datas.region !== "" && datas.zone != "" && "Zone"}</th> {/* Header for FilterName */}
                                <th style={tableHeaderStyle}>Employee </th>
                                <th style={tableHeaderStyle}>Present </th>
                                {/* <th style={tableHeaderStyle}>Absent Count</th>
                                    <th style={tableHeaderStyle}>Weekoff Count</th> */}
                                <th style={tableHeaderStyleLastState}>Percentage</th>
                            </tr>
                        </thead>
                        {
                            dashboardData.length > 0 ?

                                <tbody>
                                    {dashboardData.map((item, index) => (
                                        <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
                                            <td style={tableCellStyle} className="LabelNamesstate">{item.FilterName}</td> {/* Filter Name Here */}
                                            <td style={tableCellStyle}>{item.employee_count || 0}</td>
                                            <td style={tableCellStyle}>{item.present_count || 0}</td>
                                            {/* <td style={tableCellStyle}>{item.absent_count || 0}</td>
                                        <td style={tableCellStyle}>{item.weekoff_count || 0}</td> */}
                                            <td style={tableCellStyle}>
                                                {item.percentage_attendance ? `${Number(item.percentage_attendance).toFixed(2)}%` : '0%'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                                :
                                <tbody>
                                    <tr key={0} style={{ borderBottom: "1px solid #ccc" }}>
                                        <td colspan="6" style={tableCellStyle}>{"No data Available"}</td>
                                    </tr>
                                </tbody>
                        }

                    </table>

                </div>
                {
                    chartData.length != 0 ?

                        <div style={{ minWidth: "645px", minHeight: "337px", overflowX: "scroll", marginTop: "25px" }}>
                            <div style={{ width: "1200px", height: "315px" }}> {/* Set a wide fixed width */}
                                <ResponsiveContainer width={1200}  height={303} >
                                    <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="state"
                                            tick={{ fontSize: 10, dy: 10 }}
                                            interval={0}
                                            angle={-25}
                                            tickFormatter={(value) => value.length > 7 ? `${value.substring(0, 9)}...` : value}
                                        />
                                        <YAxis

                                            tickFormatter={(value) => `${value == "PRECENTAGE" ? `${value}%` : value}`}
                                        />
                                        <Tooltip
                                            formatter={(value, name) =>
                                                name === 'PRECENTAGE' ? `${value}%` : value
                                            }
                                        />
                                        <Legend />
                                        <Bar dataKey="present_percentage" stackId="a" fill="#4CAF50" fontSize={12} name="PRESENT" />
                                        <Bar dataKey="working_percentage" stackId="a" fill="#FFD54F" fontSize={12} name="WORKING" />
                                        <Bar dataKey="others" stackId="a" fill="#430bee" fontSize={12} name="OTHERS" />

                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                        :
                        null}

            </div>


            {/* :
                null} */}
        </>
    )
}

export default AdvanceSeondState